import * as Zod from "zod";
import * as Tokens from "~/domain/tokens";

export const responseDecoder = Zod.object({
  identity: Tokens.v1IdentityClaimsDecoder.nullish(),
  identityV2: Tokens.v2IdentityClaimsDecoder.nullish(),
  anonymousId: Zod.string(),
  isVendrInternalEmployee: Zod.boolean().default(false),
  isSyntheticTest: Zod.boolean().default(false),
  isAuthenticatedWithVendrPlatform: Zod.boolean().default(false),
  platformOptedInCookie: Zod.string().nullish(),
  newLandingPageEnabled: Zod.boolean().default(false),
});

export type Response = Zod.infer<typeof responseDecoder>;

export const defaultResponse: Response = {
  identity: null,
  identityV2: null,
  anonymousId: "",
  isVendrInternalEmployee: false,
  isAuthenticatedWithVendrPlatform: false,
  isSyntheticTest: false,
  platformOptedInCookie: null,
  newLandingPageEnabled: false,
};
